import { Card } from "flowbite-react";

const AboutUs = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-center mb-12">About Us</h1>

      {/* About Us Section */}
      <div className="mb-12">
        <h2 className="text-3xl font-semibold mb-4">About Us</h2>
        <p className="text-lg text-gray-700 leading-relaxed">
          At NILO, we believe in leveling the playing field for athletes while
          empowering fans to directly support their favorite teams. Our platform
          enables athletes to crowd-source Name, Image, and Likeness (NIL)
          deals, giving them opportunities to monetize their brand while
          focusing on their performance. By connecting athletes with their
          fanbases and local communities, we aim to create a more equitable
          system that benefits all athletes, not just the stars. Together, we
          can help your favorite teams win more games while ensuring every
          player has a chance to succeed, both on and off the field.
        </p>
      </div>

      {/* Why We Made NILO Section */}
      <div className="mb-12">
        <h2 className="text-3xl font-semibold mb-4">Why We Made NILO</h2>
        <p className="text-lg text-gray-700 leading-relaxed">
          Derek would tell you that NILO was built so that he and 180 million
          other rabid college fans could participate in NIL endorsements in a
          way that's interesting and competitve. He wants to use NIL to make his
          favorite team better, and he believes most other fans do too.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed">
          Craig, on the other hand, would tell you that NIL isn't fair - and it
          should be. He would say we built NILO so that non-revenue generating
          sport athletes can get access to a cut of the support the big name QBs
          and WRs are getting. Craig fights for NILO because it opens the door
          for more women to get a slice of the NIL pie, and lets athletes focus
          on their careers and their academics with enough money in their
          pockets to afford books and food.
        </p>
      </div>

      {/* CEO Section */}
      <div className="flex flex-col items-center mb-12">
        <Card className="w-full md:w-1/2 bg-white shadow-lg rounded-lg p-6">
          <div className="flex flex-col md:flex-row items-center">
            <img
              src="/img/derek.png"
              alt="CEO"
              className="w-32 h-32 rounded-full mb-4 md:mb-0 md:mr-6"
            />
            <div>
              <h2 className="text-2xl font-bold">Derek Chadwell</h2>
              <h3 className="text-lg font-semibold text-gray-600">CEO</h3>
              <p className="mt-4 text-gray-700">
                Derek is the CEO of our company with over 15 years of experience
                in engineering and innovation. He drives the company’s mission
                to create NIL value for all players. His favorite team is the NC
                State Wolfpack (also his alma mater).
              </p>
            </div>
          </div>
        </Card>
      </div>

      {/* CTO Section */}
      <div className="flex flex-col items-center mb-12">
        <Card className="w-full md:w-1/2 bg-white shadow-lg rounded-lg p-6">
          <div className="flex flex-col md:flex-row items-center">
            <img
              src="/img/anoop.png"
              alt="CTO"
              className="w-32 h-32 rounded-full mb-4 md:mb-0 md:mr-6"
            />
            <div>
              <h2 className="text-2xl font-bold">Anoop Rajendra</h2>
              <h3 className="text-lg font-semibold text-gray-600">CTO</h3>
              <p className="mt-4 text-gray-700">
                Anoop is our CTO and software leader with over 18 years of
                experience in the industry. He loves to build highly scalable,
                and highly performant software platforms. He likes to adventure,
                trying flying, sailing, scuba, and surfing, with varying degrees
                of success
              </p>
            </div>
          </div>
        </Card>
      </div>

      {/* PMO Section */}
      <div className="flex flex-col items-center mb-12">
        <Card className="w-full md:w-1/2 bg-white shadow-lg rounded-lg p-6">
          <div className="flex flex-col md:flex-row items-center">
            <img
              src="/img/craig.jpg"
              alt="PMO"
              className="w-32 h-32 rounded-full mb-4 md:mb-0 md:mr-6"
            />
            <div>
              <h2 className="text-2xl font-bold">Craig Chadwell</h2>
              <h3 className="text-lg font-semibold text-gray-600">CPO</h3>
              <p className="mt-4 text-gray-700">
                Craig is our chief product guy, overseeing all things product
                market fit and customer satisfaction. He excels at making
                connections and finding the thread of what we need.
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AboutUs;
